import styled from 'styled-components';
import { StockSliceStyled } from '../StockSliceStyled';

export const StockSliceStyledOV = styled(StockSliceStyled)`
    .header,
    .vehicles {
        background: ${({ theme }) => theme.colors.pureWhite};
    }
`;
